/**
 * Global pass through styling for components
 * https://primevue.org/passthrough/#global
 */
export default {
  /*
   * Button
   */
  Button: {
    root: {
      class: 'rounded-lg !text-14',
      style: {
        '--p-form-field-border-radius': 'var(--radius-lg)',
        '--p-button-outlined-secondary-border-color': 'var(--color-neutral-40)',
        '--p-button-outlined-secondary-color': 'var(--color-neutral-80)',
      },
    },
    label: 'text-14',
  },

  /*
   * ToggleButton
   */
  ToggleButton: {
    root: 'w-full',
    Content: 'flex items-center gap-2',
    Label: 'text-14',
  },

  /*
   * SelectButton
   */
  SelectButton: {
    root: 'rounded-lg',
  },

  /*
   * Checkbox
   */
  Checkbox: {
    Box: 'rounded-md text-14',
  },

  /*
   * Dialog
   */
  Dialog: {
    root: {
      class: [
        'border-none',
        'sm:w-auto w-full',
        'sm:h-auto h-[100svh] max-h-[100svh]',
        'sm:rounded-2xl rounded-none',
      ],
    },
    content: 'h-full py-4 px-3',
    header: 'h-14 border-b border-neutral-20 px-3',
    footer: 'border-t border-neutral-20 p-3',
  },

  /*
   * Toast
   */
  Toast: {
    Summary: 'font-bold',
    Detail: 'm-0',
    Message: 'rounded-r-xl',
    CloseButton: 'w-6 h-6',
    CloseIcon: 'w-4 h-4',
  },

  /*
   * Message
  */
  Message: {
    root: 'rounded-lg',
  },

  /*
   * Textarea
   */
  Textarea: {
    root: '!text-14 !leading-[150%] !rounded-lg',
  },

  /*
   * InputText
   */
  InputText: {
    root: '!text-14 !leading-[150%] !rounded-lg',
  },

  /*
   * Select
   */
  Select: {
    root: 'rounded-lg',
    Label: 'text-14 leading-[150%]',
    Header: 'p-2',
    Overlay: 'overflow-hidden rounded-xl',
    List: 'pt-0 pb-0',
    OptionLabel: 'text-14',
  },

  /*
   * Card
   */
  Card: {
    root: 'shadow-medmastery !rounded-2xl',
    content: 'p-0',
    body: 'sm:p-8 p-4',
  },

  /*
   * Skeleton
   */
  Skeleton: {
    root: 'rounded-lg',
  },

  /*
   * TabMenu
   */
  TabMenu: {
    Item: {
      style: {
        '--p-tabmenu-item-border-width': '0px 0px 2px 0px',
        '--p-tabmenu-item-background': 'transparent',
        '--p-tabmenu-item-color': 'var(--color-neutral-60)',
        '--p-tabmenu-item-active-color': 'var(--color-primary)',
      },
    },
    Tablist: 'w-full',
    ActiveBar: 'transition-all',
    ItemLabel: 'text-14',
  },

  /*
   * Menu
   */
  Menu: {
    root: {
      class: 'p-0 rounded-xl',
    },
    Item: 'rounded-md',
    ItemContent: 'rounded-md',
    List: 'p-1',
  },

  /*
   * Accordion
   */
  Accordion: {
    root: 'gap-4 flex flex-col',
  },
  AccordionPanel: {
    root: 'rounded-2xl shadow-medmastery overflow-hidden',
    headerAction: 'p-4 border-none',
  },
  AccordionHeader: {
    root: {
      style: {
        'background': 'white',
      },
      class: 'border-none',
    },
    ToggleIcon: {
      style: {
        'display': 'none',
      },
    },
  },
  AccordionContent: {
    Content: 'p-0 border-none',
  },

  /*
   * Stepper
   */
  StepList: {
    root: 'px-0 md:px-4 md:py-0 py-4',
  },
  Step: {
    Header: 'flex flex-col gap-2 items-center',
    Title: 'text-14 text-neutral-60',
    Number: 'md:text-16 text-14',
  },
  StepPanels: {
    root: 'p-0',
  },
  StepPanel: {
    root: 'bg-transparent p-0',
  },
};
